import { useMemo } from "react";

import {
  IAppealGetterParams,
  TAppealFilter,
} from "~/entity/Appeals/model/schema";
import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { getDealerGroupFilter } from "~/shared/ui/FIlterPresets/DefaultFilterView/model/lib";

/**
 * Собирает серверный фильтр из плоских значений URL. filterItems в query
 * хранится строкой через запятую (сериализация мультивыбора Filter.Root).
 */
export const toServer = (filter: TAppealFilter): IAppealGetterParams => {
  const itemsForService = String(filter.filterItems ?? "")
    .split(",")
    .filter(Boolean);
  const dealerGroupFilter = getDealerGroupFilter(
    filter.filterBy as keyof FILTER_BY,
    itemsForService,
  );
  return {
    dealerGroup: {
      ids: dealerGroupFilter?.ids || [],
      cities: dealerGroupFilter?.cities || [],
      FOs: dealerGroupFilter?.FOs || [],
      countries: dealerGroupFilter?.countries || [],
      subjects: dealerGroupFilter?.subjects || [],
    },
    year: filter.year as string,
    quarter: filter.quarter as string,
    appealStatus: filter.appealStatus as IAppealGetterParams["appealStatus"],
    resolutionStatus:
      filter.resolutionStatus as IAppealGetterParams["resolutionStatus"],
    malusStatus: filter.malusStatus as IAppealGetterParams["malusStatus"],
  };
};

export const useAppealServerFilter = (
  filter: TAppealFilter,
): IAppealGetterParams => {
  return useMemo(
    () => toServer(filter),
    [
      filter.year,
      filter.quarter,
      filter.appealStatus,
      filter.resolutionStatus,
      filter.malusStatus,
      filter.filterBy,
      filter.filterItems,
    ],
  );
};
